'use client';

import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { h3TextBlock } from '@/uiComposites/typography/headings';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';

import { useAnchorInViewport } from './AlphabetizedAnchorInViewportContext';
import { slugify } from '@/globals/helpers/slugify.helpers';
import { AlphabetLetter, numericKey } from './AlphabetAnchorLink.types';

export const AlphabetAnchorLink = ({
	letter,
	'data-link-type': dataLinkType,
}: {
	'data-link-type': string;
	letter: AlphabetLetter;
}) => {
	const alphabetAnchorInViewport = useAnchorInViewport();

	const isActiveLetter = alphabetAnchorInViewport === letter;

	return (
		<DOPLink
			href={`#${slugify(letter)}`}
			className={classes(
				box({
					paddingBlock: '1 | h3',
					paddingInline: '-1 | small',
					backgroundColor: isActiveLetter ? 'negative' : 'transparent',
				}),
			)}
			data-link-type={dataLinkType}
		>
			<span
				className={classes(
					h3TextBlock({
						color: 'positiveBlue:noVisited',
					}),
				)}
			>
				{letter === numericKey ? '#' : letter}
			</span>
		</DOPLink>
	);
};

export const AlphabetInactiveAnchorLink = ({
	letter,
}: {
	letter: AlphabetLetter;
}) => {
	if (letter === numericKey) {
		return null;
	}
	return (
		<div
			className={classes(
				box({
					paddingBlock: '1 | h3',
					paddingInline: '-1 | small',
				}),
			)}
		>
			<span className={classes(h3TextBlock({ color: 'positiveMuted' }))}>
				{letter}
			</span>
		</div>
	);
};
